import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-template-category-modal',
  templateUrl: './template-category-modal.component.html',
  styleUrls: ['./template-category-modal.component.css']
})
export class TemplateCategoryModalComponent {
  flag: boolean;
  er1: boolean = false
  er2: boolean = false
  er3: boolean = false
  er4: boolean = false
  er5: boolean = false
  er6: boolean = false
  er7: boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, public dialog: MatDialog, public dialogRef: MatDialogRef<TemplateCategoryModalComponent>
  ) {

  }
  public template: string
  public type: string[] = []
  AddTemplateCategory(event) {

    this.data.template = event.target.value
    if (this.data.template.match('^[a-zA-Z]+[a-zA-Z ]*$') == null) {
      this.er1 = true
    }
    else {
      this.er1 = false
    }
  }
  AddTemplateDesc(event) {
    this.data.templateDescription = event.target.value
    if (this.data.templateDescription.match('^[a-zA-Z]+[a-zA-Z ]*$') == null) {
      this.er2 = true
    }
    else {
      this.er2 = false
    }
  }

  AddSubTemplateCategory(event) {

    this.data.templateTypes = event.target.value
    if (this.data.templateTypes.match('^[a-zA-Z]+[a-zA-Z, ]*$') == null) {
      this.er3 = true
    }
    else {
      this.er3 = false
    }

    if (this.data.templateTypes.includes(',')) {
      this.data.templateTypes = this.data.templateTypes.split(',')
    }
    else {
      if (this.data.templateTypes.length > 0)
        this.data.templateTypes = [this.data.templateTypes]
    }
    this.type = this.data.templateTypes
    this.data.templateTypes = this.type



  }

  close() {
    this.dialogRef.close()
  }

  closeDialog() {
    this.flag = true

    if (!(this.data.template.match('^[a-zA-Z]+[a-zA-Z ]*$') == null) && !(this.data.templateDescription.match('^[a-zA-Z]+[a-zA-Z ]*$') == null)) {
      this.dialogRef.close(this.data)
    }
    else {
      return;
    }

  }
  closeDialog1() {
    this.flag = true

    if (!this.er3 && this.data.templateTypes.length > 0)
      this.dialogRef.close(this.data)
    else
      return

  }

  closeDialog2() {
    this.flag = true

    if (!(this.data.compliance.match('^[a-zA-Z]+[a-zA-Z ]*$') == null)) {
      this.dialogRef.close(this.data)
    }
    else {
      return;
    }

  }

  AddComplianceType(event){
    this.data.compliance = event.target.value
    if (this.data.compliance.match('^[a-zA-Z]+[a-zA-Z ]*$') == null) {
      this.er4 = true
    }
    else {
      this.er4 = false
    }
  }

  closeDialog3() {
    this.flag = true

    if (!(this.data.region.match('^[a-zA-Z]+[a-zA-Z ]*$') == null)) {
      this.dialogRef.close(this.data)
    }
    else {
      return;
    }

  }

  AddRegion(event){
    this.data.region = event.target.value
    if (this.data.region.match('^[a-zA-Z]+[a-zA-Z ]*$') == null) {
      this.er5 = true
    }
    else {
      this.er5 = false
    }
  }

  closeDialog4() {
    this.flag = true

    if (!(this.data.country.match('^[a-zA-Z]+[a-zA-Z ]*$') == null)) {
      this.dialogRef.close(this.data)
    }
    else {
      return;
    }

  }

  AddCountry(event){
    this.data.country = event.target.value
    if (this.data.country.match('^[a-zA-Z]+[a-zA-Z ]*$') == null) {
      this.er5 = true
    }
    else {
      this.er5 = false
    }
  }

  closeDialog5() {
    this.flag = true

    if (!(this.data.city.match('^[a-zA-Z]+[a-zA-Z-, ]*$') == null)) {
      this.dialogRef.close(this.data)
    }
    else {
      return;
    }

  }

  AddCity(event){
    this.data.city = event.target.value
    if (this.data.city.match('^[a-zA-Z]+[a-zA-Z-, ]*$') == null) {
      this.er5 = true
    }
    else {
      this.er5 = false
    }
  }

  AddOfficeLocation(event){
    this.data.location = event.target.value
    if (this.data.location.match('^[a-zA-Z]+[a-zA-Z-, ]*$') == null) {
      this.er7 = true
    }
    else {
      this.er7 = false
    }
  }

  closeDialog6() {
    this.flag = true
    if (!(this.data.location.match('^[a-zA-Z]+[a-zA-Z-, ]*$') == null)) {
      this.dialogRef.close(this.data)
    }
    else {
      return;
    }
  }

}
